import React from 'react';
import { useTranslation } from 'react-i18next';
import { GlobeAltIcon } from '@heroicons/react/24/outline';

const LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' }
];

const isLanguageActive = (i18n, code) => {
  const current = (i18n.resolvedLanguage || i18n.language || 'fr').toLowerCase();
  return current === code || current.startsWith(`${code}-`);
};

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="pt-4 mt-4 border-t border-gray-200">
      <div className="flex items-center gap-2 mb-3">
        <GlobeAltIcon className="h-5 w-5 text-gray-500" aria-hidden />
        <p className="text-sm font-medium text-gray-700">{t('profile.language')}</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {LANGUAGES.map((language) => {
          const active = isLanguageActive(i18n, language.code);
          return (
            <button
              key={language.code}
              type="button"
              onClick={() => changeLanguage(language.code)}
              className={`
                inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium border transition-colors
                ${active
                  ? 'border-blue-600 bg-blue-50 text-blue-700'
                  : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'}
              `}
              aria-pressed={active}
            >
              <span className="text-lg" aria-hidden>
                {language.flag}
              </span>
              <span>{language.name}</span>
              {active && <span className="text-blue-600">✓</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LanguageSwitcher;